<p> Обновляет должен сохраниться выбор</p>
<button (click)="onRefresh()"> REFRESH </button>

<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (selectChange)="selected = $event"
></aur-mat-table>

<p>Выбранные</p>
{{selected|json}}

